export default __webpack_public_path__ + "static/media/i_kaia.063a42b8.svg";